// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2gZls","container":"styles_container__2LH1-","title":"styles_title__29rme","wrapper":"styles_wrapper__1JrRf","answer":"styles_answer__2gE19"};